const steps = [
  {
    id: 'guide-1',
    title: '先看清信息是否完整',
    desc: '只看到一半就下结论，是围观最常见的翻车方式。问自己一句：我看到的，是全部吗？',
  },
  {
    id: 'guide-2',
    title: '给自己设一个围观时限',
    desc: '十分钟可以，一小时就要警惕了。给刷屏设个闹钟，是保护注意力的第一道防线。',
  },
  {
    id: 'guide-3',
    title: '别急着站队和转发',
    desc: '情绪最激动的时候，恰恰是最不需要按下转发键的时候。等一等，信息往往会自己浮上来。',
  },
  {
    id: 'guide-4',
    title: '把注意力还给自己',
    desc: '别人的故事再精彩，也只是佐餐小菜。吃完记得回到自己的桌边，那才是主菜。',
  },
];

export default function Guide() {
  return (
    <section id="guide" className="w-full bg-primary-950 py-14 md:py-20">
      <div className="w-full px-4 md:px-8">
        <div className="max-w-2xl">
          <span className="inline-flex items-center gap-2 text-xs md:text-sm px-3 py-1 rounded-full bg-primary-800 text-primary-100">
            <i className="ri-compass-3-line" />
            围观指南
          </span>
          <h2 className="font-heading text-2xl md:text-4xl text-background-50 mt-3 md:mt-4">
            理性吃瓜的四步自检
          </h2>
          <p className="mt-3 text-sm md:text-base leading-relaxed text-background-200">
            我们不反对吃瓜，只希望你吃得清醒。这四步很轻，但在情绪上头的时候特别管用。
          </p>
        </div>

        <ol className="mt-10 md:mt-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
          {steps.map((step, index) => (
            <li
              key={step.id}
              className="rounded-lg bg-primary-900 border border-primary-800 p-5 md:p-6 flex flex-col"
            >
              <span className="font-heading text-3xl text-accent-400">0{index + 1}</span>
              <h3 className="font-heading text-base md:text-lg text-background-50 mt-3">{step.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-background-300">{step.desc}</p>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}